import { HomeCampaignSettings } from '@/types/ads';

export const defaultHomeSettings: HomeCampaignSettings = { enabled: false, placement: 'HOME_SLIDE', mediaUrl: '', durationSeconds: 15, muted: true, everyNItems: 3, allowKids: false, allowSports: false };
